












































































































































import { Vue, Component, Lifecycle, Watch } from "av-ts";

import Fetcher from "../../services/Fetcher";
import UserService from "../../services/UserService";
import TopicService from "../../services/TopicService";
import QuestionService from "../../services/QuestionService";
import TopicPicker from "./TopicPicker.vue";
import VueSlider from "vue-slider-component";

import { IOfferingUser, IOffering, ITopic, IQuestionImport } from "../../interfaces/models";

@Component({
    components: {
        TopicPicker,
        VueSlider
    }
})
export default class ImportQuestions extends Vue {
    currentUser: IOfferingUser | undefined = undefined;

    universityList: string[] | undefined = undefined;
    selectedUniversity: string = "";

    courseList: string[] | undefined = undefined;
    selectedCourse: string = "";

    pOfferingList: IOffering[] | undefined = undefined;
    selectedOffering: string = "";

    currentTopicList: ITopic[] | undefined = undefined;
    topics: ITopic[] | undefined = undefined;
    selectedTopics: ITopic[] = [];

    minEffectiveness: number = 0;
    minCorrectness: number = 0;

    importQuestionCount: number | undefined = undefined;
    importSuccessful: number | undefined = undefined;
    
    set offeringList(newList: IOffering[] | undefined) {
        this.pOfferingList = newList;
        if (this.pOfferingList !== undefined) {
            let index = this.pOfferingList!.map(x => x.offeringID)
                .indexOf(this.currentUser!.offering.offeringID);
            if (index >= 0) {
                this.pOfferingList.splice(index, 1);
            }
            if (this.pOfferingList.length == 0) {
                this.selectedOffering = "There are no valid offerings for this course.";
            }
        }
    }

    get offeringList() {
        return this.pOfferingList;
    }

    updateCurrentTopics(topics: ITopic[]) {
        this.currentTopicList = topics;
    }

    updateOfferingUser(user: IOfferingUser) {
        this.currentUser = user;
    }

    updateUniversities(uniList: string[]) {
        this.universityList = uniList;
    }

    getImportParams(): IQuestionImport {
        return {
            fromOfferingID: this.selectedOffering,
            toOfferingID: this.currentUser!.offering!.offeringID,
            topics: this.selectedTopics,
            minEffectiveness: this.minEffectiveness,
            minCorrectness: this.minCorrectness
        };
    }

    searchQuestions() {
        if (this.selectedOffering !== undefined && this.selectedTopics.length > 0) {
            let importParams: IQuestionImport = this.getImportParams();
            QuestionService.getQuestionsForImport(importParams)
                .then(x => this.importQuestionCount = x);
        } else {
            this.importQuestionCount = undefined;
        }
        this.importSuccessful = undefined;
    }

    toggleTopic(topic: ITopic) {
        let index = this.selectedTopics!.indexOf(topic);
        if (index < 0) {
            this.selectedTopics.push(topic);
        } else {
            this.selectedTopics.splice(index, 1);
        }
    }

    topicSelected(topic: ITopic) {
        return this.selectedTopics.indexOf(topic) >= 0;
    }

    resetSearch() {
        this.importQuestionCount = undefined;
        this.importSuccessful = undefined;
    }

    importQuestions() {
        let importParams: IQuestionImport = this.getImportParams();
        QuestionService.importQuestions(importParams)
            .then(x => this.importSuccessful = x);
    }

    getImportButtonClass() {
        return {
            "md-raised": true,
            "md-primary": this.buttonActive()
        };
    }

    buttonActive() {
        return this.importQuestionCount && this.importQuestionCount > 0;
    }

    @Watch("selectedUniversity")
    handleUniChange(newUni: string, _oldUni: string) {
        if (newUni !== undefined && newUni != "") {
            TopicService.getCoursesForUni(newUni).then(x => this.courseList = x);
        }
        this.selectedCourse = "";
    }

    @Watch("selectedCourse")
    handleCourseChange(newCourse: string, _oldCourse: string) {
        if (newCourse !== undefined && newCourse != "") {
            TopicService.getOfferingsForCourse(newCourse).then(x => this.offeringList = x);
        }
        this.selectedOffering = "";
    }

    @Watch("selectedOffering")
    handleOfferingChange(newOffering: string, _oldCourse: string) {
        if (newOffering !== undefined && newOffering != "") {
            TopicService.getTopicsForOffering(newOffering).then(
                x => this.topics = x.filter(y => this.currentTopicList!.map(t => t.name).indexOf(y.name)>=0)
            );
        }
        this.topics = undefined;
        this.selectedTopics = [];
    }

    @Watch("selectedTopics")
    handleTopicChange(_newTopics: ITopic[], _oldTopics: ITopic[]) {
        this.searchQuestions();
    }

    @Watch("minEffectiveness")
    handleEffectivenessChange(_new: number, _old: number) {
        this.searchQuestions();
    }

    @Watch("minCorrectness")
    handleCorrectnessChange(_new: number, _old: number) {
        this.searchQuestions();
    }

    @Lifecycle
    created() {
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateOfferingUser);
        Fetcher.get(UserService.getUniversities)
            .on(this.updateUniversities);
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateCurrentTopics);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateOfferingUser);
        Fetcher.get(UserService.getUniversities)
            .off(this.updateUniversities);
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateCurrentTopics);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/ImportQuestions.vue